import React from 'react';

import { Modal, Button } from 'antd';

const CustomModal = ({
  title,
  visible,
  buttonName,
  closeModal,
  action,
  content,
  className = null,
  loading = false,
}) => {
  return (
    <Modal
      className={`action-modal ${className}`}
      visible={visible}
      title={title}
      onCancel={() => closeModal()}
      footer={[
        <>
          <Button
            loading={loading}
            key="1"
            className="ant-btn ant-btn-primary"
            onClick={action}
          >
            {buttonName}
          </Button>
          <Button
            key="2"
            className="btn-secondary border-danger"
            type="ghost"
            onClick={() => closeModal()}
          >
            Cancel
          </Button>
        </>,
      ]}
    >
      {content}
    </Modal>
  );
};

export default CustomModal;
